'use client';

import { type RoadMapUpdate } from '@/domain/roadmap/types';
import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { RichTextEditor } from '@andritzot/metris-web-ui/inputs/rich-text-editor';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { type Control, Controller } from 'react-hook-form';

import { FieldActionsWrapper } from './shared/FieldActionsWrapper';
import { RichTextEditorExtensions } from '@/components/common/RichTextEditorExtensions/RichTextEditorExtensions';

interface DetailedDescriptionFieldProps {
  viewOnly: boolean;
  control: Control<RoadMapUpdate, unknown>;
}

export function DetailedDescriptionField({ viewOnly, control }: Readonly<DetailedDescriptionFieldProps>) {
  return (
    <Box sx={{ py: 0.75 }}>
      <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5, color: 'text.secondary' }}>
        Detailed Description
      </Typography>
      <Controller
        name="detailedDescription"
        control={control}
        render={({ field: { value, onChange } }) => (
          <FieldActionsWrapper>
            <RichTextEditor onChange={(event) => onChange(event)} value={value ?? ''} controls={<RichTextEditorExtensions />} disabled={viewOnly} />
          </FieldActionsWrapper>
        )}
      />
    </Box>
  );
}
